import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function StickyMobileCTA() {
  const handleScrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-40 md:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" data-id="element-237">
      <div className="flex flex-col gap-1 max-w-md mx-auto" data-id="element-238">
        <button onClick={handleScrollToOffer} className="w-full bg-primary hover:bg-primary-hover text-white font-heading font-bold text-lg py-3 px-4 rounded-lg shadow-lg transition-colors h-12 flex items-center justify-center uppercase tracking-wide" data-id="element-239">
          Comprar $23.999
        </button>
        <div className="flex items-center justify-center gap-1 text-xs text-charcoal-muted mt-1" data-id="element-240">
          <ShieldCheck className="w-3 h-3 text-trust" data-id="element-241" />
          <span data-id="element-242">Garantía 7 días • Pago Seguro</span>
        </div>
      </div>
    </div>;
}